/**
 * Escape a string for safe interpolation into an HTML context — element text or
 * a double/single-quoted attribute value.
 *
 * This mirrors the server's `apps/pictufy/src/lib/escapeHtml.ts`, which the SSR
 * views have always used. The bundle had no equivalent at all while building
 * HTML strings out of user data (search terms, artist names, artwork titles,
 * server error messages) and handing them to `innerHTML` /
 * `insertAdjacentHTML`. There is no CSP to fall back on for the older pages
 * either, so escaping at the sink is the whole defence.
 *
 * Prefer not needing it: Preact escapes JSX children automatically, and
 * `setText`/`textContent` are safe by construction. Reach for this only where an
 * HTML string genuinely has to be built by hand.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
